import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { addressDescriptionItem, contactDescriptionItems } from '@app/icare/components/entity/EntityDescriptionItems'
import { DoctorSpecialityEnum } from '@app/icare/entities/doctor/schema/Doctor'
import { DoctorEditDrawer } from '@app/icare/routes/_app/praxen/-components/DoctorEditDrawer'
import { t } from '@lingui/core/macro'
import { EditSectionButton } from '@pkg/ui/button'
import { TypedDescriptionsItem } from '@pkg/ui/proValueTypes'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'

export const Route = createFileRoute('/_app/praxen/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  const doctor = data

  return (
    <Flex vertical gap="small">
      <ProCard
        headerBordered
        title={t`Allgemein`}
        extra={<EditSectionButton onClick={() => void DoctorEditDrawer.show({ id: data.id, section: 'basic' })} />}
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Fachrichtung`}>
            {doctor.speciality ? DoctorSpecialityEnum.$.getLabel(doctor.speciality) : undefined}
          </TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Titel`}>{doctor.title}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Name`}>{doctor.name}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Namenszusatz`}>{doctor.nameComplement}</TypedDescriptionsItem>
          {addressDescriptionItem(doctor.address)}
          {contactDescriptionItems(doctor.contact)}
        </ProDescriptions>
      </ProCard>
      <ProCard
        headerBordered
        title={t`Sonstiges`}
        extra={<EditSectionButton onClick={() => void DoctorEditDrawer.show({ id: data.id, section: 'misc' })} />}
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Bemerkungen`}>{doctor.comment}</TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>
    </Flex>
  )
}
